import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useTrocaAutomaticaHorarioOutletContext } from '@/pages/TrocaAutomaticaHorario'
import { trocaHorario } from '@/service/api'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

export default function ExcluirTrocaAutomaticaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaAutomaticaHorarioOutletContext()
    const item = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } =
        trocaHorario.trocaAutomatica.mutations.useDelete({
            invalidateQuery: true,
        })

    if (!item) return null

    const handleSubmit = () =>
        mutateAsync(item.id, {
            onSuccess: () => {
                toast.success('Troca automática excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'TrocaAutomáticaDeHorário'])}
        >
            <Dialog.Content>
                Realmente deseja excluir a troca automática de horário de
                <br />
                {item.Funcionario?.nome}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
